import React, { useEffect, useState } from 'react';
import { Free, Enterprise, Starter, GridDetails, Pro } from '../Shared/Subscription/SubscriptionInfo';
import { useTranslation } from 'react-i18next';

function ComparePlanTable() {

    const [showData, setShowData] = useState(false);

    const { t, i18n, ready } = useTranslation("payment/compare_plan_table", { useSuspense: false });

    useEffect(() => {
        if (ready) {
            debugger
            // i18n.changeLanguage("ar")
        }
    }, [ready])

    return (
        <>
            <div className="w-100 d-flex justify-content-center mt-5 pt-5">
                <button 
                    className='d-flex justify-content-center align-items-center border-0 btn-compare'
                    onClick={() => setShowData(!showData)}>
                    <h3>
                        {t("title")}
                    </h3>
                    &nbsp;&nbsp;
                    <i className={`fa-solid fa-chevron-${showData ? 'up' : 'down'} font-size-5 chevron`} />
                </button>
            </div>
            {
                showData &&
                <div className='mt-4 pt-5'>
                <div className="w-100 d-flex justify-content-center compare"
                style={{ overflow: "auto", height: "550px" }}>
                    <table className="w-100 mt-4 table">
                        <colgroup>
                            <col className="col-md-2"></col>
                            <col className="col-md-1"></col>
                            <col className="col-md-1"></col>
                            <col className="col-md-1"></col>
                            <col className="col-md-1"></col>
                        </colgroup>
                        <thead style={{position: "sticky", top: 0 , background: "#FFFFFF"}}>
                            <tr>
                                <th
                                    className="py-2 px-0 border-2"
                                    scope="col"
                                    style={{
                                        background:'#ffffff'
                                        }}
                                ></th>
                                <th className="py-2 px-0" scope="col"
                                  style={{
                                    // borderBottom: `2px solid ${Free.color}`
                                    background:'#ffffff'
                                    }}>
                                    <h4
                                        style={{
                                            fontSize: "18px",
                                            fontWeight: 500,
                                            color:Free.color
                                        }}
                                    >
                                        Free
                                    </h4>
                                </th>
                                <th className="py-2 px-0" scope="col"
                                 style={{
                                    background:'#ffffff'
                                    // borderBottom: `2px solid ${Starter.color} `
                                    }}>
                                    <h4
                                        style={{
                                            
                                            fontSize: "18px",
                                            fontWeight: 500,
                                            color:Starter.color
                                        }}
                                    >
                                        Starter
                                    </h4>
                                </th>
                                <th className="py-2 px-0" scope="col"
                                style={{
                                    // borderBottom: `2px solid ${Pro.color} `,
                                    background:'#ffffff'}}>
                                    <h4
                                        style={{
                                            fontSize: "18px",
                                            fontWeight: 500,
                                            color:Pro.color
                                        }}
                                    >
                                        Pro
                                    </h4>
                                </th>
                                <th className="py-2 px-0" scope="col"
                                style={{
                                    background:'#ffffff'
                                    // borderBottom: `2px solid ${Growth.color} `
                                }}
                                    >
                                    <h4
                                        style={{
                                            fontSize: "18px",
                                            fontWeight: 500,
                                            color: "#2D4AB2"
                                        }}
                                    >
                                        Enterprise
                                    </h4>
                                </th>
                            </tr>
                        </thead>
                        <tbody className='section-color'>
                            {GridDetails.map(
                                (info, index) => (
                                    <>
                                        <tr key={index} className="border-top">
                                            <td>
                                                <b className='ps-5 me-2 font-weight-2'>{info.section}</b>
                                            </td>
                                            <td className="border-top-0"></td>
                                            <td className="border-top-0"></td>
                                            <td className="border-top-0"></td>
                                            <td className="border-top-0"></td>
                                        </tr>
                                        {info.properties.map(
                                            (property, pIndex) => (
                                                <tr className='section-border'>
                                                    <td>
                                                        <span className='ps-5'>
                                                            {t(property.property.toLowerCase().replace(/[^a-zA-Z]/g, "_"))}
                                                        </span>
                                                        <span
                                                            className='float-end pe-5 me-3'
                                                            style={{color: "#BDBCBC"}}
                                                        >
                                                            <i class="mx-1 fal fa-info-circle" title={property.tooltip}></i>
                                                        </span>
                                                    </td>
                                                    <td>
                                                        {property.Free ===
                                                            true ? (
                                                            <i className="fas fa-check" 
                                                            style={{color:Free.color}}/>
                                                        ) : (
                                                            property.Free
                                                        )}
                                                        {/* {property.Free ===
                                                            false && (
                                                                <i className="" />
                                                            )} */}
                                                    </td>
                                                    <td>
                                                        {property.Standard ===
                                                            true ? (
                                                            <i className="fas fa-check" 
                                                            style={{ color:Starter.color}}/>
                                                        ) : (
                                                            property.Standard
                                                        )}
                                                        {/* {property.Standard ===
                                                            false && (
                                                                <i className="" />
                                                            )} */}
                                                    </td>
        
                                                    <td>
                                                        {property.Pro ===
                                                            true ? (
                                                            <i className="fas fa-check"
                                                            style={{ color:Pro.color}} />
                                                        ) : (
                                                            property.Pro
                                                        )}
                                                        {/* {property.Pro ===
                                                            false && (
                                                                <i className="" />
                                                            )} */}
                                                    </td>
                                                    <td>
                                                        {property.Enterprise ===
                                                            true ? (
                                                            <i className="fas fa-check"
                                                            style={{ color:Enterprise.color}} />
                                                        ) : (
                                                            property.Enterprise
                                                        )}
                                                        {/* {property.Pro ===
                                                            false && (
                                                                <i className="" />
                                                            )} */}
                                                    </td>
                                                   </tr>
                                            )
                                        )}
                                    </>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
                </div>
            }
        </>
    )
}

export default ComparePlanTable;